//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"LineFontType",1,0],[0,"OutlineColor",1,0],[0,"OverrideColor",1,0],[1,"SelectObject",0,"SelectDisplayableObjectList",0],[0,"Translucency",1,0]],[],[]];
SPLM.Assemblies.ProductOutlineBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.ProductOutlineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.ProductOutlineBuilder.LineFont = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "Longdash" : "Longdash", "Dotdash" : "Dotdash", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

export default SPLM;